import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import PromotionReviewStatusCorner from './PromotionReviewStatusCorner';
import PromotionReviewStatusLabel from './PromotionReviewStatusLabel';

const PromotionReviewItem = ({
 categoryId, categoryName, review, onReviewSelected,
}) => {
  const { clientId, promotionId } = useParams();
  return (
    <div className="promotion-review-item">
      <Card>
        <Link className="card-content" to={`/client/${clientId}/${promotionId}/${review.id}/${categoryId}`}>
          <div className="content">
            <div className={`subtitle${review.status === 'closed' ? ' disabled' : ''}`}>{categoryName}</div>
            <div className={`title${review.status === 'closed' ? ' disabled' : ''}`}>{review.name}</div>
            {review.isFinal ? <div className={`final${review.status === 'closed' ? ' disabled' : ''}`}>FINAL</div> : ''}
          </div>
          <PromotionReviewStatusCorner status={review.status} isFinal={review.isFinal} />
          <PromotionReviewStatusLabel status={review.status} isFinal={review.isFinal} isLive={review.isLive} />
        </Link>
      </Card>
    </div>
  );
};

PromotionReviewItem.propTypes = {
  categoryId: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  review: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    date: PropTypes.string,
    status: PropTypes.string,
    isFinal: PropTypes.bool,
    isLive: PropTypes.bool,
  }).isRequired,
  onReviewSelected: PropTypes.func.isRequired,
};

export default PromotionReviewItem;
